require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-mongodb.json") })
        }
      }, "path---package-bs-mongodb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-mongodb!./.cache/json/package-bs-mongodb.json
// module id = 802
// module chunks = 231608221292675